import { TYPE_COLLECTION } from './input-types';
import { STORE } from '../constants';

export const id = STORE;
export const apiKey = 'StoreGuid';
export const type = TYPE_COLLECTION;

export const store = {
  id,
  apiKey,
  type,
};
